import cookies from "react-cookies";

export default function requestHandler(config) {
    const token = cookies.load("app_access_token") ?? "";

    config.headers.Authorization = `Bearer ${token}`;

    return config;
}